
import React, { useEffect, useState } from 'react';
import TruncateText from './TruncateText';
import { useSelector } from 'react-redux';
import { fadeIn, slideIn, staggerContainer, textVariant, } from "./utils/motion";
import { motion } from "framer-motion";
export const VisionSection = () => {

  const data = useSelector((state) => state.cart.constants);   
  const vision = useSelector((state) => state.cart.vision);   
  const lang = useSelector((state) => state.cart.lang);

  const [more,setMore] = useState(false)

  const [index,setIndex] = useState(-1)
  const [width, setWidth] = useState(window.innerWidth);
  

  const svg =[
    'Vector1.svg',
    'Vector2.svg',
    'Vector3.svg'
  ]


  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
  //  console.log(window.innerWidth);
    return () => window.removeEventListener("resize", handleResize);
    
  
  }, []);


  return (
    <motion.section
    variants={staggerContainer()}
   initial='hidden'
   whileInView='show'
   viewport={{  amount: 0.25 }} className="relative mt-2  w-full ">
   <span className='hash-span' id={'VisionSection'}>
   
   </span>
  <div className="relative flex flex-col w-full  ">

 
 <div dir='ltr' style={{zIndex:1}}  className=" items-center absolute flex top-0 w-full h-full ">
          
          
 <img alt='alhubaishi Vision' style={{maxHeight:'100%'}} className='' width={'90%'} height='auto' src='img/Vision.png'/>

            </div>


<div style={{zIndex:2}} dir='rtl'  className={` px-8 relative flex flex-col   w-full`}>
{ vision.length> 0 ?
  vision.map((item, i) => (
<motion.div  variants={slideIn('right', '', i*0.3, 1)}  key={`vision${i}`} style={{height:`${(width*0.3)/2}px`}} className='relative  rounded-2xl px-4 bg-[#f4f4f4]/80 mb-10 min-h-[180px] min-w-[300px] max-h-[250px] max-w-[400px] w-[30%] '>

<h2  dir={lang=== 'en' ?  "ltr" : "rtl" } style={{placeContent:'center',fontFamily:'CairoBold',background: `linear-gradient(to top right,  ${item.color} 0%, #f4f4f4 120%)` }} className={`flex text-white  absolute rounded-md top-2 ${lang === 'en' ? 'left-2' : 'right-2' } w-[130px] xl:w-[170px] h-[50px]`} >
<img className='m-2' width={20} height={20} src={`https://alhubaishi.future-swift.com/Icons/${item.icon}`} alt={`الحبيشي ${item.title}`} /> <div className='m-auto w-full'>{lang === 'en' ? item.title_en:item.title } </div> 
 </h2>

<motion.p variants={fadeIn('left','',i*0.3+0.5 ,0.7)} style={{overflowY:index === i ?'auto' :'hidden',height:`${((width*0.3)/2)-55}px`}} className={`max-h-[190px] min-h-[120px] w-full h-max px-1 mt-[60px]  ${lang === 'en' ? 'text-left':'text-right' } `}>
  {
    index === i ?  
    
    lang === 'en' ? item.description_en : item.description
    :
    lang === 'en' ? TruncateText(item.description_en,width> 1300? width/5> 400 ? 400 :  width /5  : 150):TruncateText(item.description,width> 1300? width/5> 400 ? 400 :  width /5  : 150)  }
{width> 1300? 
  width/5 > 400 ? 
  lang === 'en' ? item.description_en.length > 400 ? 
  
  <span onClick={()=>{
  if(index !== i){
    setIndex(i)
  }else{
    setIndex(-1)
  }
}} className='text-blue-500 cursor-pointer'>{index === i ? 'Less' :'More'}</span> 

:'' 
  
  
  : item.description.length > 400 ? 
  <span onClick={()=>{
  if(index !== i){
    setIndex(i)
  }else{
    setIndex(-1)
  }
}} className='text-blue-500 cursor-pointer'>{  index === i ? 'القليل' : 'المزيد'}</span> 

:'' 
 
:   lang === 'en' ? item.description_en.length  > width/5 ? 

<span onClick={()=>{
  if(index !== i){
    setIndex(i)
  }else{
    setIndex(-1)
  }
}} className='text-blue-500 cursor-pointer'>{ index === i ? 'Less' :'More' }</span> 
 :'' 

: item.description.length  > width/5 ?  
<span onClick={()=>{
  if(index !== i){
    setIndex(i)
  }else{
    setIndex(-1)
  }
}} className='text-blue-500 cursor-pointer'>{ index === i ? 'القليل' : 'المزيد'}</span> 
 :'' 
 

 :  lang === 'en' ? item.description_en.length > 150 ?
 
 <span onClick={()=>{
  if(index !== i){
    setIndex(i)
  }else{
    setIndex(-1)
  }
}} className='text-blue-500 cursor-pointer'>{index === i ? 'Less' :'More'}</span> 
 :'' 
 
 
 : item.description.length > 150 ? 
 <span onClick={()=>{
  if(index !== i){
    setIndex(i)
  }else{
    setIndex(-1)
  }
}} className='text-blue-500 cursor-pointer'>{ index === i ? 'القليل' : 'المزيد'}</span> 
 :'' 
 
 }

</motion.p>

</motion.div>

)):''}

</div>
    
  </div>
   


  <div className='relative mt-5 min-h-[150px] md:min-h-[250px] lg:min-h-[250px] sm:min-h-[200px] xs:lg:min-h-[150px]'>
        
        
        <div  style={{zIndex:1}}  className="items-center absolute flex top-0 w-full h-full ">
          
            <h2 style={{fontSize:'max'}} className="relative m-auto text-center leading-none  text-[100px] xl:text-[300px] lg:text-[250px] md:text-[200px] sm:text-[150px] xs:text-[100px] text-neutral-100 ">
              Hubaishi
            </h2>

            </div>




            <motion.div variants={slideIn('left', '', 0.3, 1)} style={{zIndex:2}} className="relative px-8 flex top-0 w-full items-center min-h-[150px] md:min-h-[250px] lg:min-h-[250px] sm:min-h-[200px] xs:lg:min-h-[150px]">
            <div style={{fontFamily:'CairoBold'}} className="m-auto flex items-center  p-1 text-black ">
            
            
            <div className="m-auto w-[30%]  ">
                <img
                  src="img/founder.png"
                  className="object-contain gap-0 w-full "
                  alt="Founder"
                />
                <motion.p variants={textVariant(1)} className="mt-5 text-[7px]  xl:text-[15px] lg:text-[13px] md:text-[10px] sm:text-[8px] xs:text-[7px]">
                  {lang === 'en'  ? 'Founder / Mohammed Abdullah Al-Hubaishi' : 'المؤسس الحاج / محمد عبدالله الحبيشي'}
                </motion.p>
              </div>

              <div style={{justifyContent:'center'}} className="w-[70%]  m-auto ">
              <motion.p variants={textVariant(1)} className= {`${lang === 'en' ? 'text-left' :'text-right'}   text-[12px] xl:text-[30px] lg:text-[25px] md:text-[18px] sm:text-[15px] xs:text-[12px] p-1`}>
            
                {
                  
              lang=== 'en' ?  
                  
                    
                data&&data.length ?
                    
                  
                  data&&data[7].value_en?.length > 200 ? 
                      <>
                    {more ? data&&data[7].value_en : TruncateText(data&&data[7].value_en , 200)}
                    <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                    
                    {more ? 'القليل' : 'المزيد'}
                    
                    </span> 
                    </>
                    :data&&data[7].value_en 
                
                 :''



              : 
                

                   data&&data.length ?
                    
                  
                    data&&data[7].value?.length > 200 ? 
                        <>
                      {more ? data&&data[7].value : TruncateText(data&&data[7].value , 200)}
                      <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                      
                      {more ? 'القليل' : 'المزيد'}
                      
                      </span> 
                      </>
                      :data&&data[7].value 
                  
                   :''
                    }

             
               
              
            
              </motion.p>
              </div>


          </div>


          </motion.div>


        
</div>

    </motion.section>
  );
};
